import scheduleMaintenance from './middleware/scheduleMaintenance'
import checkAPI from './middleware/checkAPI'
import auth from './middleware/auth'
import checkEligible from './middleware/checkEligible'
import checkEligibleAPE  from './middleware/checkEligibleAPE'
import isUserPrincipal from './middleware/isUserPrincipal'

export default [
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('./../components/Navbar.vue'),
        children: [
            // Member Information
            {
                path: 'info/',
                name: 'userInfo',
                meta: {
                    title: 'Member\'s Information',
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/MemberInfo.vue')
            },

            // Member Dependents
            {
                path: 'dependents/',
                name: 'depedent',
                meta: {
                    title: 'Member Dependents',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI, isUserPrincipal]
                },
                component: () => import('./../components/DashboardChildren/MemberDependents.vue')
            },

            // Member Utilizations
            {
                path: 'util/',
                name: 'userUtil',
                meta: {
                    title: 'Member Utilizations',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/MemberUtil.vue')
            },

            // Affliation
            {
                path: 'affiliations/',
                name: 'Affiliations',
                meta: {
                    title: 'Affiliated Facillities and Physicians',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/Partners/PartnersSearch.vue')
            },

            // Affiliated Hospitals
            {
                path: 'affiliations/hospitals/',
                meta: {
                    title: 'Affiliated Hospitals',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/AffiliatedSubComponents/Hospitals.vue')
            },

            // Affiliated Doctors
            {
                path: 'affiliations/doctors/',
                meta: {
                    title: 'Affiliated Doctors',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/AffiliatedSubComponents/Doctors.vue')
            },

            // Affiliated Clinics
            {
                path: 'affiliations/clinics/',
                meta: {
                    title: 'Affiliated Clinics',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/AffiliatedSubComponents/Clinics.vue')
            },

            // Bills and Benefit Limits
            {
                path: 'bills-limits/',
                meta: {
                    title: 'Bills and Benefit Limits',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/MemberBillsMBL.vue')
            },

            // Excess Hospital Bills
            {
                path: 'bills-limits/ehb/',
                meta: {
                    title: 'Excess Hospital Bills',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/MemberBillsMBL/ExcessHospital.vue')
            },

            // Maximum Benefit Limit
            {
                path: 'bills-limits/mbl/',
                meta: {
                    title: 'Maximum Benefit Limit',
                    retuiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/MemberBillsMBL/MaximumBenefit.vue')
            },

            // Out-Patient Consultation
            {
                path: 'consultation/',
                meta: {
                    title: 'Out-Patient Consultation',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/OPPAPage.vue')
            },

            // Consultation Approval
            {
                path: 'consultation/main/',
                meta: {
                    title: 'Consultation Approval',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/ConsultationSubComponents/ConsultationPage.vue')
            },

            // OPPAN History
            {
                path: 'consultation/history/',
                meta: {
                    title: 'OPPAN History',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/ConsultationSubComponents/HistoryOppan.vue')
            },

            // Out-Patient Consultation Request Slip
            {
                path: 'consultation/request/',
                meta: {
                    title: 'Out-Patient Consultation Request Slip',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI, checkEligible]
                },
                component: () => import('./../components/DashboardChildren/ConsultationSubComponents/RequestForm/index.vue')
            },

            // Request Consultation Denied
            {
                path: 'consultation/request/denied',
                meta: {
                    title: 'Request Consultation Denied',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI, checkEligible]
                },
                component: () => import('./../components/DashboardChildren/ConsultationSubComponents/ApprovalResultDenied.vue')
            },

            // Request Consultation Granted
            {
                path: 'consultation/request/granted',
                meta: {
                    title: 'Request Consultation Granted',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI, checkEligible]
                },
                component: () => import('./../components/DashboardChildren/ConsultationSubComponents/ApprovalResultGranted.vue')
            },

            // Annual Physical Exam
            {
                path: 'annual-physical-exam',
                meta: {
                    title: 'Annual Physical Exam',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/AnnualPhysicalExam.vue')
            },

            // APE Approval
            {
                path: 'annual-physical-exam/main',
                meta: {
                    title: 'APE Approval',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/AnnualPhysicalExam/APEPage.vue')
            },

            // APE Request
            {
                path: 'annual-physical-exam/request',
                meta: {
                    title: 'APE Request',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI, checkEligibleAPE]
                },
                component: () => import('./../components/DashboardChildren/AnnualPhysicalExam/RequestForm/index.vue')
            },

            // APE Revalidate
            {
                path: 'annual-physical-exam/revalidate',
                meta: {
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/AnnualPhysicalExam/APERevalidate/IndexPage.vue')
            },

            // APE Request Granted
            {
                path: 'annual-physical-exam/request/granted',
                meta: {
                    title: 'APE Request Granted',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/AnnualPhysicalExam/ApprovalResultGranted.vue')
            },

            // APE Request Denied
            {
                path: 'annual-physical-exam/request/denied',
                meta: {
                    title: 'APE Request Denied',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/AnnualPhysicalExam/ApprovalResultDenied.vue')
            },

            // Availment Proc
            {
                path: 'availment-proc/',
                meta: {
                    title: 'Availment Procedure',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/AvailmentProc.vue')
            },

            // Out-Patient Request Procedure
            {
                path: 'out-patient-request-proc/',
                meta: {
                    title: 'Out-Patient Request Procedure',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/MemberGuidelines/OCRComp.vue')
            },

            // Definition of terms
            {
                path: 'terms/',
                meta: {
                    title: 'Definition of terms',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/MemberGuidelines/DOT.vue')
            },

            // Benefits & Services
            {
                path: 'benefits/',
                meta: {
                    title: 'Benefits & Services',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/MemberGuidelines/BOS.vue')
            },

            // Membership Fee & Philhealth
            {
                path: 'fees-ph/',
                meta: {
                    title: 'Membership Fee & Philhealth',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/MemberGuidelines/MembFee_PH.vue')
            },

            // Claims
            {
                path: 'claims/',
                meta: {
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/MemberGuidelines/Claims.vue')
            },

            // Exclusions
            {
                path: 'exclusions/',
                meta: {
                    title: 'Exclusions',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/MemberGuidelines/Exclusions.vue')
            },

            // FAQs
            {
                path: 'faqs/',
                meta: {
                    title: 'FAQs',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/MemberGuidelines/FAQs.vue')
            },

            // Data Privacy
            {
                path: 'data-privacy/',
                meta: {
                    title: 'Data Privacy',
                    requiresAuth : true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/MemberGuidelines/DataPrivacy.vue')
            },

            // Manage Account
            {
                path: 'manageAccount/',
                meta: {
                    title: 'Manage Account',
                    requiresAuth: true,
                    middleware: [scheduleMaintenance, auth, checkAPI]
                },
                component: () => import('./../components/DashboardChildren/ManageAccount.vue')
            }
        ]
    }
]
